import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SettingsModule} from './settings/settings.module';
import {TablesModule} from './tables/tables.module';
import {EtlModule} from './etl-v1/etl.module';
import {StatisticsModule} from './statistics/statistics.module';
import {ViewModule} from './view/view.module';
import {MarketingModule} from './marketing/marketing.module';
import {AdminModule} from './admin/admin.module';
import {AccountModule} from './account/account.module';
import {LandingPageModule} from './landing-page/landing-page.module';
import {PopupModule} from './popup/popup.module';
import {CampaignModule} from './marketing/campaign/campaign.module';
import {CampaignGroupModule} from './marketing/campaign-group/campaign-group.module';
import {BlocHtmlModule} from './marketing/bloc-html/bloc-html.module';
import {ViewEditorModule} from './view-editor/view-editor.module';
import {TagsModule} from './tags/tags.module';
import {WorkflowOldModule} from './workflow-old/workflow-old.module';
import {WorkflowModule} from './workflow/workflow.module';
import {InvoicingModule} from './invoicing/invoicing.module';
import {ForbiddenErrorModule} from './forbidden-error/forbidden-error.module';
import {TenantTransferModule} from './tenant-transfer/tenant-transfer.module';
import {DashboardModule} from './dashboard/dashboard.module';
import {HomeModule} from './home/home.module';


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SettingsModule,
        TablesModule,
        EtlModule,
        StatisticsModule,
        MarketingModule,
        AdminModule,
        AccountModule,
        BlocHtmlModule,
        CampaignModule,
        CampaignGroupModule,
        LandingPageModule,
        PopupModule,
        WorkflowOldModule,
        WorkflowModule,
        InvoicingModule,
        ForbiddenErrorModule,
        TenantTransferModule,
        DashboardModule,
        HomeModule
    ],
    exports: [
        SettingsModule,
        TablesModule,
        ViewModule,
        LandingPageModule,
        ViewEditorModule,
        TagsModule,
        TenantTransferModule,
        DashboardModule
    ],
})
export class PagesModule {}
